import React from "react";
import AdminHeader from "../components/Layout/AdminHeader";
import AdminSideBar from "../components/Admin/Layout/AdminSideBar";
import AdminTagManagement from "../components/Admin/AdminTagManagement";

const AdminTagManager = () => {
  return (
    <div className="admin-dashboard-container">
      <AdminHeader />
      <div className="admin-dashboard-content">
        <div className="admin-dashboard-wrapper">
          <div className="admin-dashboard-sidebar">
            <AdminSideBar active={10} />
          </div>
          <div className="admin-dashboard-main admin-page-shell">
            <header className="admin-page-hero">
              <div>
                <p className="admin-page-eyebrow">Super Admin Taxonomy</p>
                <h1>Tag Manager</h1>
                <p className="admin-page-copy">Manage reusable tags and taxonomy controls for organized platform discovery.</p>
              </div>
            </header>
            <AdminTagManagement />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminTagManager;
